import React from 'react';
import PropTypes from 'prop-types';
import { StyledInline } from './style';

const Inline = ({
  children,
  alignItems = 'center',
  columnGap,
  justifyContent,
  mt,
  mb,
  tag,
}) => {
  return (
    <StyledInline
      alignItems={alignItems}
      columnGap={columnGap}
      justifyContent={justifyContent}
      mt={mt}
      mb={mb}
      as={tag}
    >
      {children}
    </StyledInline>
  );
};

Inline.propTypes = {
  children: PropTypes.node,
  alignItems: PropTypes.string,
  columnGap: PropTypes.string,
  justifyContent: PropTypes.string,
  mt: PropTypes.string,
  mb: PropTypes.string,
  tag: PropTypes.string,
};

export default Inline;
